import createLucideIcon from '../createLucideIcon';

/**
 * @component @name ClockArrowUp
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNnY2bDEuNTYuNzgiIC8+CiAgPHBhdGggZD0iTTEzLjIyNyAyMS45MjVhMTAgMTAgMCAxIDEgOC43NjctOS41ODgiIC8+CiAgPHBhdGggZD0ibTE0IDE4IDQtNCA0IDQiIC8+CiAgPHBhdGggZD0iTTE4IDIydi04IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/clock-arrow-up
 * @see https://lucide.dev/guide/packages/lucide-react-native - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ClockArrowUp = createLucideIcon('ClockArrowUp', [
  ['path', { d: 'M12 6v6l1.56.78', key: '14ed3g' }],
  ['path', { d: 'M13.227 21.925a10 10 0 1 1 8.767-9.588', key: 'jwkls1' }],
  ['path', { d: 'm14 18 4-4 4 4', key: 'ftkppy' }],
  ['path', { d: 'M18 22v-8', key: 'su0gjh' }],
]);

export default ClockArrowUp;
